import { getReviewToken, setReviewToken, toast } from "../api.js";

/**
 * Contractor/admin inbox for first-party captured leads + consent.
 */
export function renderLeadsAdmin(_pack) {
  return `
    <h1>Opt-in inbox</h1>
    <p class="sub">People who asked for a consult — you may contact them only the ways they allowed</p>
    <aside class="help-tip" role="note">
      <div class="help-tip-title">What is this?</div>
      <div class="help-tip-body">
        These are <strong>homeowner opt-ins</strong> from your public form (Get leads).
        They sync automatically to this PC every 15 minutes. Share the form link or QR to grow this list.
      </div>
    </aside>
    <div class="panel">
      <div class="toolbar" style="flex-wrap:wrap;gap:.5rem">
        <label class="muted">Admin password (if set)
          <input id="lead-token" type="password" placeholder="Only if your site requires it" style="min-width:12rem" />
        </label>
        <button type="button" class="btn" id="lead-save-token">Save</button>
        <button type="button" class="btn primary" id="lead-refresh">Refresh list</button>
        <button type="button" class="btn" id="lead-export">Download JSON</button>
        <a class="btn primary" href="#/capture">Open capture form</a>
      </div>
      <p class="muted small">Tip: put the capture link on flyers, texts you already have consent for, and your dealer website.</p>
    </div>
    <div id="leads-table-wrap"><p class="muted">Click <strong>Refresh list</strong> to load opt-ins.</p></div>
  `;
}

function rowHtml(L) {
  const c = L.consent || {};
  const name = [L.first_name, L.last_name].filter(Boolean).join(" ") || "—";
  const cons = [
    c.sms ? "SMS" : null,
    c.call ? "Call" : null,
    c.email ? "Email" : null,
  ]
    .filter(Boolean)
    .join("·");
  return `<tr>
    <td class="muted">${(L.created_at || "").slice(0, 16)}</td>
    <td><strong>${esc(name)}</strong><br/><span class="muted">${esc(L.interest || "")}</span></td>
    <td>${esc(L.address || "")}<br/><span class="muted">${esc(L.city || "")} ${esc(L.zip || "")}</span></td>
    <td class="muted">☎ ${esc(L.phone || "—")}<br/>✉ ${esc(L.email || "—")}</td>
    <td><span class="badge b-blue">${esc(cons || "—")}</span><br/><span class="muted small">${esc(c.version || "")}</span></td>
    <td class="muted small">${esc(L.source || "")}<br/>${esc(L.id || "")}</td>
  </tr>`;
}

function esc(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function renderTable(leads, note) {
  const wrap = document.getElementById("leads-table-wrap");
  if (!wrap) return;
  if (!leads.length) {
    wrap.innerHTML = `<p class="muted">${note || "No leads yet. Share #/capture or wait for form submits."}</p>`;
    return;
  }
  wrap.innerHTML = `
    <p class="muted">${leads.length} lead(s)${note ? " · " + note : ""}</p>
    <div style="overflow-x:auto">
      <table class="data">
        <thead>
          <tr>
            <th>When</th><th>Name / interest</th><th>Property</th>
            <th>Contact</th><th>Consent</th><th>Source / id</th>
          </tr>
        </thead>
        <tbody>${leads.map(rowHtml).join("")}</tbody>
      </table>
    </div>`;
}

export function mountLeadsAdmin() {
  const tokInput = document.getElementById("lead-token");
  if (tokInput) tokInput.value = getReviewToken();

  document.getElementById("lead-save-token")?.addEventListener("click", () => {
    setReviewToken(tokInput?.value || "");
    toast("Token saved in this browser");
  });

  document.getElementById("lead-refresh")?.addEventListener("click", () => loadRemote());
  document.getElementById("lead-export")?.addEventListener("click", () => exportRemote());
  document.getElementById("lead-local")?.addEventListener("click", () => {
    try {
      const list = JSON.parse(localStorage.getItem("leadforge_local_leads_v1") || "[]");
      renderTable(list.reverse(), "browser localStorage backup");
    } catch {
      renderTable([], "no local backups");
    }
  });

  loadRemote();
}

async function loadRemote() {
  const headers = {};
  const tok = getReviewToken();
  if (tok) headers["X-LeadForge-Token"] = tok;
  try {
    const res = await fetch("/api/leads", { headers });
    if (res.status === 401) {
      renderTable([], "unauthorized — set admin token");
      toast("Unauthorized — set LEAD_ADMIN_TOKEN", true);
      return;
    }
    const data = await res.json();
    if (!res.ok) {
      renderTable([], data.error || "load failed");
      return;
    }
    window.__lf_leads = data.leads || [];
    renderTable(window.__lf_leads, data.source || "");
  } catch (e) {
    renderTable([], "API unavailable — use browser backups or deploy Functions");
  }
}

async function exportRemote() {
  let leads = window.__lf_leads;
  if (!leads) {
    await loadRemote();
    leads = window.__lf_leads || [];
  }
  const blob = new Blob([JSON.stringify({ leads, exported_at: new Date().toISOString() }, null, 2)], {
    type: "application/json",
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `leadforge-inbound-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  toast("Exported JSON — run: python -m leadforge import-leads --file …");
}
